import {BananaSpinner} from './BananaSpinner';

export const LoaderBig = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        margin: 'auto',
      }}
    >
      <BananaSpinner width={50} height={50} />
    </div>
  );
};
